<template>
  <Header :current="step" />
  <Info @onNext="onInfoNext()" v-if="infoVisible" />
  <Payment @onPrev="onPaymentPrev()" v-if="paymentVisible" />
</template>

<script setup>
import Info from "./Info";
import Header from "./Header";
import Payment from "./Payment";
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";

const router = useRouter();
const store = useStore();

const infoVisible = ref(false);
const paymentVisible = ref(false);
const step = ref(1);
const user = computed(() => store.getters['auth/user']);

watch(() => user, () => {
  showCurrentStep();
});

onMounted(() => {
  showCurrentStep();
})

const onInfoNext = () => showPayment();
const onPaymentPrev = () => showInfo();
const showInfo = () => {
  step.value = 1;
  infoVisible.value = true;
  paymentVisible.value = false;
}

const showPayment = () => {
  step.value = 2;
  infoVisible.value = false;
  paymentVisible.value = true;
}

const showCurrentStep = () => {
  if (user.value.registration_completed) {
    return router.push({name: 'dashboard'});
  }


  if (!user.value.current_brand_id) {
    showInfo();
  } else {
    showPayment();
  }
}

</script>

<style lang="scss" scoped>

</style>
